import { Routes, Route } from "react-router-dom";
import { LangProvider } from "./contexts/LangContext";
import SmoothScroll from "./components/SmoothScroll";
import ScrollToTop from "./components/ScrollToTop";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import AnalyticsTracker from "./components/AnalyticsTracker";
import StructuredData from "./components/StructuredData";
import Home from "./pages/Home";
import Cases from "./pages/Cases";
import CaseDetail from "./pages/CaseDetail";
import Privat from "./pages/Privat";
import Arkitekter from "./pages/Arkitekter";
import Om from "./pages/Om";
import Kontakt from "./pages/Kontakt";
import CookiePolicy from "./pages/CookiePolicy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

// Router-agnostic app tree: BrowserRouter in the browser, StaticRouter at prerender time.
const AppContent = () => (
    <LangProvider>
        <div className="App">
            <StructuredData />
            <SmoothScroll>
                <ScrollToTop />
                <AnalyticsTracker />
                <Navigation />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/cases" element={<Cases />} />
                    <Route path="/cases/:slug" element={<CaseDetail />} />
                    <Route path="/privat" element={<Privat />} />
                    <Route path="/arkitekter" element={<Arkitekter />} />
                    <Route path="/om-os" element={<Om />} />
                    <Route path="/kontakt" element={<Kontakt />} />
                    <Route path="/cookie-politik" element={<CookiePolicy />} />
                    <Route path="/vilkaar" element={<Terms />} />
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
                <CookieConsent />
            </SmoothScroll>
        </div>
    </LangProvider>
);

export default AppContent;
